module.exports = __webpack_public_path__ + "static/media/snaxaApp.b050fd4b.jpg";